export type ChatbotView = "floating" | "sidebar" | "fullscreen";

export const DEFAULT_VIEW: ChatbotView = "floating";
